import React from 'react'
import List from '../pages/list'

export const PagesThirdLegalList = (props) => <List {...props} filter={{ collection: 'third_legal' }} title="Third legal pages" />

export default PagesThirdLegalList
